import { Button } from '@playbooks/ui/components/button'
import { useAppContext } from '../contexts/AppContext'
import { Mouse } from 'lucide-react'
import { useRef, useState } from 'react'
import { cn } from '@playbooks/ui/lib/utils'
import useMountEffect from '../hooks/useMountEffect'

export default function ScrollDownButton({ handleClick }: { handleClick: () => void }) {
  const ref = useRef<HTMLButtonElement>(null)
  const [doBouncing, setDoBouncing] = useState(true)

  const onClick = () => {
    setDoBouncing(false)
    handleClick()
  }

  useMountEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!ref.current) return
            ref.current.style.opacity = '1'
          } else {
            if (!ref.current) return
            ref.current.style.opacity = '0'
          }
        })
      },
      {
        root: null,
        threshold: 0,
      },
    )

    const element = ref.current

    if (element) {
      observer.observe(element)
    }

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  })

  return (
    <Button
      ref={ref}
      size="icon-lg"
      type="button"
      variant="ghost"
      onClick={onClick}
      className={cn('z-50 hover:bg-transparent! transition-opacity opacity-0')}
    >
      <Mouse className={cn('size-6 relative', doBouncing && 'animate-bounce top-0.5')} />
    </Button>
  )
}
